export default __webpack_public_path__ + "static/media/infopng.7fe241fd.png";